export let LocationValidationErrorCode = /*#__PURE__*/function (LocationValidationErrorCode) {
  LocationValidationErrorCode["stateError"] = "stateError";
  LocationValidationErrorCode["addressError"] = "addressError";
  return LocationValidationErrorCode;
}({});
export let LocationVerificationCode = /*#__PURE__*/function (LocationVerificationCode) {
  LocationVerificationCode["verified"] = "verified";
  LocationVerificationCode["suggested"] = "suggested";
  LocationVerificationCode["notFound"] = "notFound";
  return LocationVerificationCode;
}({});
export let LocationErrorCode = /*#__PURE__*/function (LocationErrorCode) {
  LocationErrorCode["locationRequestError"] = "locationRequestError";
  return LocationErrorCode;
}({});